'use client';

import { BILLING_PERIODS } from '@/entities/plan';
import { isTeamEnabled, UserProfile } from '@/entities/user-profile';
import { useState } from 'react';
import { PlanPicker, type PlanPickerValue } from '@/features/subscription-plan-picker';


type ComponentProps = {
    profile: UserProfile | null;
};


export function PlanPickerSection ({ profile }: ComponentProps) {
    const [ value, setValue ] = useState<PlanPickerValue>({
        billing_period: profile?.billing_period ?? BILLING_PERIODS[0],
        plan_id       : profile?.plan_id ?? '',
    });

    return (
        <PlanPicker
            value={ value }
            onChange={ setValue }
            teamEnabled={ isTeamEnabled(profile) }
        />
    );
}
